import { render, staticRenderFns } from "./DocProductType.vue?vue&type=template&id=62697d6b&"
import script from "./DocProductType.vue?vue&type=script&lang=js&"
export * from "./DocProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocProductType.vue"
export default component.exports